import { Link } from 'react-router-dom';
import { GraduationCap, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-50 dark:bg-slate-950 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4" data-testid="footer-logo">
              <div className="w-10 h-10 rounded-xl bg-lime-500 flex items-center justify-center overflow-hidden">
                <img src="/logo.png" alt="VisaInterviews.ai" className="w-7 h-7 object-contain" />
              </div>
              <span className="font-heading font-bold text-xl">
                Visa<span className="text-lime-500">interviews</span>.ai
              </span>
            </Link>
            <p className="text-sm text-muted-foreground mb-6 max-w-sm leading-relaxed">
              AI-enabled interview practice platform designed to help users confidently prepare for CAS Shield interviews, visa interviews, and IELTS speaking tests.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-muted-foreground hover:bg-lime-500 hover:text-white transition-colors" data-testid="social-facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-muted-foreground hover:bg-lime-500 hover:text-white transition-colors" data-testid="social-twitter">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-muted-foreground hover:bg-lime-500 hover:text-white transition-colors" data-testid="social-instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-muted-foreground hover:bg-lime-500 hover:text-white transition-colors" data-testid="social-youtube">
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-muted-foreground hover:text-lime-500 transition-colors" data-testid="footer-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-lime-500 transition-colors" data-testid="footer-about">
                  About
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-muted-foreground hover:text-lime-500 transition-colors" data-testid="footer-pricing">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-muted-foreground hover:text-lime-500 transition-colors" data-testid="footer-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Useful Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-lime-500 transition-colors" data-testid="footer-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-lime-500 transition-colors" data-testid="footer-terms">
                  Terms and Conditions
                </Link>
              </li>
              <li>
                <Link to="/ai-transparency" className="text-sm text-muted-foreground hover:text-lime-500 transition-colors" data-testid="footer-ai-transparency">
                  AI Transparency Statement
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <Mail className="w-4 h-4 text-lime-500 flex-shrink-0" />
                <a href="mailto:support@visainterviews.ai" className="hover:text-lime-500 transition-colors">
                  support@visainterviews.ai
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <Phone className="w-4 h-4 text-lime-500 flex-shrink-0" />
                <a href="tel:+447380885506" className="hover:text-lime-500 transition-colors">
                  +44 738 088 5506
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4 text-lime-500 mt-0.5 flex-shrink-0" />
                <span>4 Crown Place, Liverpool Street, London, EC2A 4BT</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <p className="text-center text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} International Education Office UK. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
